import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import SubscriptionTips from './SubscriptionTips';
import useTiersModuleCounts from './useTiersModuleCounts';
import s from './SubscriptionTipsBox.scss';

const SubscriptionTipsBox: React.FC<WidgetBoxProps> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  isOwner,
  profileOwnerUser,
  section,
  zone,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const { draftCount, publishedCount, subscriberCount } =
    useTiersModuleCounts();

  return (
    <WidgetBox
      className={s['root']}
      section={section}
      zone={zone}
      header={t(`widgets.subscription_tips.header`)}
      hasMore={false}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={false}
    >
      <SubscriptionTips
        moduleId={moduleId}
        draftCount={draftCount}
        publishedCount={publishedCount}
        subscriberCount={subscriberCount}
        className={c(s['tips'], className)}
        {...props}
      />
    </WidgetBox>
  );
};

SubscriptionTipsBox.displayName = 'SubscriptionTipsBox';
export default SubscriptionTipsBox;
